import { useState, type FormEvent } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { Alert, AuthCard, Button, Input, useAuthSession } from '@concours/ui'
import { errorMessage } from '../../lib/errors'

export function ForgotPasswordPage() {
  const { t } = useTranslation()
  const { api } = useAuthSession()
  const [email, setEmail] = useState('')
  const forgot = useMutation({
    mutationFn: () => api.post('/auth/admin/password/forgot', { email }),
  })

  function submit(event: FormEvent) {
    event.preventDefault()
    forgot.mutate()
  }

  return (
    <AuthCard
      title={t('auth.forgot.title')}
      description={t('auth.forgot.description')}
      footer={<Link to="/connexion">{t('auth.forgot.back')}</Link>}
    >
      {forgot.isSuccess ? (
        <Alert tone="success">{t('auth.forgot.sent')}</Alert>
      ) : (
        <form className="stack" onSubmit={submit} noValidate>
          {forgot.isError && <Alert tone="danger">{errorMessage(forgot.error)}</Alert>}
          <Input
            label={t('auth.login.email')}
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button
            type="submit"
            variant="primary"
            size="lg"
            block
            loading={forgot.isPending}
            disabled={!email}
          >
            {t('auth.forgot.submit')}
          </Button>
        </form>
      )}
    </AuthCard>
  )
}
